'use client';

import Input from '@publishing/components/forms/input/Input';
import Dropdown from '@publishing/components/forms/dropdown/Dropdown';
import type { InputType } from '@publishing/components/forms/input/_types';
import { getFormFieldPresetKey } from '../_types';
import type { resolveField } from '../_types';

type ResolvedField = ReturnType<typeof resolveField>;

interface FieldRendererProps {
  field: ResolvedField;
  value: string;
  errorMessage?: string;
  values: Record<string, string>;
  onChange: (value: string) => void;
  className?: string;
}

/** resolveField() 결과를 받아 Input 또는 Dropdown으로 렌더 */
export default function FieldRenderer({ field, value, errorMessage, values, onChange, className }: FieldRendererProps) {
  if (field.type === 'dropdown') {
    return (
      <Dropdown
        name={field.name}
        label={field.label}
        required={field.required}
        icon={field.icon}
        options={field.options ?? []}
        value={value}
        onChange={onChange}
        errorMessage={errorMessage}
        size={field.size}
        isSheet={field.isSheet}
        className={className}
      />
    );
  }

  return (
    <Input
      type={getFormFieldPresetKey(field) ?? (field.type as InputType)}
      name={field.name}
      label={field.label}
      required={field.required}
      icon={field.icon}
      placeholder={field.placeholder}
      helperMessage={field.helperMessage}
      requiredMessage={field.requiredMessage}
      value={value}
      onChange={onChange}
      errorMessage={errorMessage}
      validate={field.validate ? (v) => field.validate!(v, values) : undefined}
      size={field.size}
      comma={field.comma}
      view={field.view}
      className={className}
    />
  );
}
